<template>
  <div class="dflexc-jcs admin-login-dialog"
    v-if="!appstore.admin_logged_in"
  >
    <h1>Admin Login</h1>
      <div class="dflexc-jcsa login-form">
        <div class="input-group">
          <label for="adminName">Name</label>
          <input type="text" v-model="form.name"/>
        </div>
        <div class="input-group">
          <label for="adminName">Password</label>
          <input type="password" v-model="form.password"/>
        </div>
        <p v-if="loginError" class="login-error">{{ loginError }}</p>
        <footer class="dflexr-jcsb btn-row">
          <button class="btn btn-cancel" @click="() => cancel()">
            Cancel
          </button>

          <button class="btn btn-submit"
            @click="submit_login"
          >Enter the Matrix</button>
        </footer>
      </div>
    </div>

</template>

<style scoped lang="scss">
  @import "../../assets/styles/admin";

  .login-error {
    color: #ffb4b4;
    margin: 0.5rem 0 0;
    text-align: left;
  }
</style>

<script setup>
// import "@/assets/styles/admin.scss"
import Router from "@/router"
import {reactive, ref} from "vue"

const appstore = window.novasectorapp
const adminServ = appstore.services.adminServ

const form = reactive({
  name: '',
  password: ''
})
const loginError = ref("")

async function submit_login() {
  loginError.value = ""
  let res
  try {
    res = await adminServ.admin_login(form)
  } catch (e) {
    loginError.value = "Could not reach the login service."
    console.error(e)
    return
  }

  if (!res || res.status !== "success") {
    loginError.value = (res && res.pkg) || "Admin login failed."
    return
  }

  update_admin_login(res.pkg.tkn)
  if (!appstore.admin_logged_in) {
    const level = res.pkg.user && res.pkg.user.level
    loginError.value = "Password accepted. Level " + level + " cannot open the admin panel."
  }
}

function update_admin_login(tkn) {
  if(tkn === undefined || tkn === null) return
  appstore.setJWT(tkn)
  // decode token to get user info
  let pkg = null
  try {
    pkg = tkn.split('.')[1]
    pkg = JSON.parse(window.atob(pkg))
  } catch (e) {
    console.log('Token not encoded correctly:', e)
    console.log('token:', tkn)
    return
  }

  const user = pkg.user
  localStorage.setItem('novasector-user', JSON.stringify(user))
  console.log('user:', user)
  appstore.admin_logged_in = appstore.adminLevel(user["level"]);

}

function cancel() {
  Router.push({name: 'home'} )
}
</script>

